var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3752 17.7269L13.5154 13.8671C12.9085 14.3931 12.2005 14.8027 11.3913 15.096C10.5821 15.3893 9.7224 15.536 8.81209 15.536C6.62734 15.536 4.77637 14.7774 3.25918 13.2602C1.74199 11.743 0.983398 9.9123 0.983398 7.768C0.983398 5.62371 1.74199 3.79297 3.25918 2.27578C4.77637 0.758594 6.61722 0 8.78175 0C10.926 0 12.7517 0.758594 14.2588 2.27578C15.7659 3.79297 16.5194 5.62371 16.5194 7.768C16.5194 8.63786 16.3778 9.47737 16.0946 10.2865C15.8114 11.0957 15.3866 11.8543 14.8202 12.5623L18.7406 16.4221C18.9227 16.584 19.0137 16.7913 19.0137 17.0442C19.0137 17.297 18.9126 17.5246 18.7103 17.7269C18.5282 17.909 18.3057 18 18.0427 18C17.7798 18 17.5572 17.909 17.3752 17.7269ZM8.78175 13.7154C10.4203 13.7154 11.8161 13.1338 12.9692 11.9706C14.1222 10.8074 14.6988 9.40657 14.6988 7.768C14.6988 6.12944 14.1222 4.72857 12.9692 3.56539C11.8161 2.40221 10.4203 1.82063 8.78175 1.82063C7.12295 1.82063 5.71197 2.40221 4.54879 3.56539C3.38561 4.72857 2.80402 6.12944 2.80402 7.768C2.80402 9.40657 3.38561 10.8074 4.54879 11.9706C5.71197 13.1338 7.12295 13.7154 8.78175 13.7154Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWeb);
export default __webpack_public_path__ + "static/media/searchWeb.ef17ee0d6e2b80a062f394710987f4f2.svg";
export { ForwardRef as ReactComponent };